export enum AppointmentType {
	oneOnOne = 'basic',
	group = 'group-video',
}
